namespace Marhaba {

    /**
     * MarhabaSearchUnit service represent wrapper over related services
     * and assigning logic for these services (according to refactoring strategy to ng2)
     */
    export class MarhabaSearchUnit {

        _terminal;
        services;
        service;

        constructor(
            private searchUnitService: SearchUnitService,
            //private Area,
            //private $route,
            private occupancyService: Core.OccupancyService,
            private broker: Core.Broker,
            private basketService,
            private resourceService: Core.ResourceService
        ) {
            this.services = this.searchUnitService.getFlightTypes();
            this.setService(this.services[0]);
            this.terminal = this.searchUnitService.getTerminal();
        }

        setService(value){
            this.service = value;
            this.searchUnitService.setFlightType(value);
        }

        set terminal(value) {
            this.searchUnitService.setTerminal(value);
            this._terminal = value;
        }

        get terminal() { // Can't directly call this.searchUnitService.getTerminal() $digest cycle
            let terminal = this._terminal;

            // First item in options menu is prompt
            if(terminal.Id === 0) {
                terminal = null;
            }

            return terminal;
        }

        set transfer(value) {
            this.searchUnitService.setMarhabaAirport(value);
        }

        get transfer() {
            return this.searchUnitService.getMarhabaAirport();
        }

        set date(value) {
            this.searchUnitService.startDate(this.mode, value);
        }

        get date() {
            return this.searchUnitService.startDate(this.mode);
        }

        set occupancy(value) {
            this.occupancyService.setOccupancy(value);
        }

        get occupancy() {
            let occupancy = this.occupancyService.getOccupancy();
            if (occupancy && occupancy.length > 1) {
                this.occupancyService.setOccupancy([this.occupancyService.reduceOccupancy()]);
                occupancy = this.occupancyService.getOccupancy();
            }
            return occupancy;
        }

        set staffRates(value) {
            this.searchUnitService.setStaffRates(value);
        }

        get staffRates() {
            return this.searchUnitService.getStaffRates();
        }

        get terminals() {
            return this.searchUnitService.getTerminals();
        }

        private get flow() {
            // return this.Area[this.$route.current.$$route.Area].flow; // Dynamic value according to tab
            return 3;
        }

        private get mode() {
            // return this.Area[this.$route.current.$$route.Area].mode; // Dynamic value according to tab
            return 3;
        }

        objectify() {
            return {
                terminal: {
                    message: this.resourceService.get('VALIDATESELECTTERMINAL'),
                    value: this.terminal
                },
                transfer: {
                    message: this.resourceService.get('VALIDATESELECTAIRPORT'),
                    value: this.transfer
                },
                date: {
                    message: this.resourceService.get('SELECTDATE'),
                    value: this.date
                }
            };
        }

        /**
         * Validate this.fields with correct values
         * invalid forms messages are published to broker services
         * @return {boolean} is form valid?
         */
        private validate() {
            let errors:any = [],
                fields = this.objectify();

            for (let name in fields) {
                if (fields.hasOwnProperty(name)) {
                    let field = fields[name];
                    if (field.value == null) {
                        errors.push(field.message);
                    }
                }
            }
            if (!this.occupancyService.childAgesPopulated(this.occupancy)) {
                errors.push(this.resourceService.get('CHILDAGESERROR'));
            }
            return errors;
        }

        /**
         * Starting search
         */
        search() {
            var errors= this.validate();
            var valid = !(errors.length > 0);
            if (valid) {
                this.basketService.startWorkflow(this.flow, null);
            }
            return valid ? null : errors;
        }

    }

    angular
        .module('marhaba')
        .service('MarhabaSearchUnit', MarhabaSearchUnit);


}
